module.exports = __webpack_public_path__ + "static/media/blamer-problem-solver.5461d899.svg";